<template>
    <v-container fluid>
        <v-slide-y-transition mode="out-in">
            <v-layout column align-center>

                <v-snackbar
                        v-model="snackbar"
                        color="warning"
                        :multi-line="false"
                        :timeout="4000"
                        :top="true"
                        :vertical="false"
                >
                    For mange bogstaver, kun 6 bogstaver!
                    <v-btn
                            dark
                            flat
                            @click="snackbar = false"
                    >
                        Close
                    </v-btn>
                </v-snackbar>

                <h1>Ruko Garant Plus</h1>

                <v-form>
                    <v-text-field
                            v-model="result"
                            label="Result"
                            :readonly="true"
                    ></v-text-field>


                    <div class="text-xs-center">
                        <v-btn fab dark color="indigo" @click="setKey('1001')">
                            1001
                        </v-btn>
                        <v-btn fab dark color="indigo" @click="setKey('1002')">
                            1002
                        </v-btn>
                        <v-btn fab dark color="indigo" @click="setKey('1003')">
                            1003
                        </v-btn>
                        <v-btn fab dark color="indigo" @click="setKey('1004')">
                            1004
                        </v-btn>
                        <v-btn fab dark color="indigo" @click="setKey('1005')">
                            1005
                        </v-btn>
                        <v-btn fab dark color="indigo" @click="setKey('1006')">
                            1006
                        </v-btn>
                        <v-btn fab dark color="indigo" @click="setKey('1007')">
                            1007
                        </v-btn>
                        <v-btn fab dark color="indigo" @click="setKey('1008')">
                            1008
                        </v-btn>
                        <v-btn fab dark color="indigo" @click="setKey('1009')">
                            1009
                        </v-btn>
                        <v-btn fab dark color="indigo" @click="setKey('1010')">
                            1010
                        </v-btn>
                        <v-btn fab dark color="indigo" @click="setKey('1011')">
                            1011
                        </v-btn>
                        <v-btn fab dark color="indigo" @click="setKey('1012')">
                            1012
                        </v-btn>
                        <v-btn fab dark color="indigo" @click="setKey('1013')">
                            1013
                        </v-btn>
                        <v-btn fab dark color="indigo" @click="setKey('1014')">
                            1014
                        </v-btn>
                        <v-btn fab dark color="indigo" @click="setKey('1015')">
                            1015
                        </v-btn>
                        <v-btn fab dark color="indigo" @click="setKey('1016')">
                            1016
                        </v-btn>
                        <v-btn fab dark color="indigo" @click="setKey('1017')">
                            1017
                        </v-btn>
                        <v-btn fab dark color="indigo" @click="setKey('1018')">
                            1018
                        </v-btn>
                        <v-btn fab dark color="indigo" @click="setKey('1019')">
                            1019
                        </v-btn>
                        <v-btn fab dark color="indigo" @click="setKey('1020')">
                            1020
                        </v-btn>
                    </div>
                </v-form>


            </v-layout>
        </v-slide-y-transition>
    </v-container>
</template>

<script>
    export default {
        name: 'HelloWorld',
        data() {
            return {
                result: '',
                snackbar: false,
            }
        },
        methods: {
            setKey(key) {

                let myKeys = [];

                myKeys["1001"] = "13 11 21 24 21";
                myKeys["1002"] = "21 11 21 24 21";
                myKeys["1003"] = "42 11 21 23 21";
                myKeys["1004"] = "13 11 13 24 21";
                myKeys["1005"] = "21 11 31 23 21";
                myKeys["1006"] = "12 11 23 21 24";
                myKeys["1007"] = "31 11 31 22 42";
                myKeys["1008"] = "42 31 31 21 11";
                myKeys["1009"] = "43 11 21 23 11";
                myKeys["1010"] = "11 31 13 24 21";
                myKeys["1011"] = "43 11 11 24 42";
                myKeys["1012"] = "23 11 21 24 21";
                myKeys["1013"] = "42 11 21 21 24";
                myKeys["1014"] = "22 11 21 21 24";
                myKeys["1015"] = "31 11 21 21 24";
                myKeys["1016"] = "43 11 12 24 21";
                myKeys["1017"] = "22 11 31 22 11";
                myKeys["1018"] = "43 31 11 22 11";
                myKeys["1019"] = "42 11 31 23 11";
                myKeys["1020"] = "42 11 11 24 21";

                this.result = myKeys[key];
            },

        }
    }
</script>
